define('TescoMobile_Customer/js/view/account/dashboard/upgrade-options',['uiComponent', 'ko', 'mage/storage', 'mage/url', 'Magento_Customer/js/customer-data', 'underscore', 'jquery', 'Magento_Catalog/js/price-utils', 'mage/translate'], function (Component, ko, storage, urlBuilder, customerData, _, $, priceUtils, $t) {
  "use strict";

  return Component.extend({
    defaults: {
      template: 'TescoMobile_Customer/account/dashboard/upgrade-options'
    },
    upgradeOptions: ko.observable({}),
    isCustomerLoggedIn: ko.observable(false),
    MPN: ko.observable(false),
    AUS: ko.observable(false),
    BAU: ko.observable(false),
    SIMO: ko.observable(false),
    visible: ko.observable(false),
    initialize: function () {
      const self = this;
      this._super();
      customerData.reload(['customer']);
      let serviceUrl = urlBuilder.build('/rest/V1/dashboard/upgrade-options-details', {});
      return storage.get(serviceUrl).done(function (response) {
        self.upgradeOptions(response);
        if (!_.isEmpty(response.upgrade_options) && !_.isEmpty(customerData.get('customer')())) {
          self.isCustomerLoggedIn(true);
          self.showUpgradeLabel(customerData.get('customer')());
        } else if (!_.isEmpty(response.upgrade_options) && _.isEmpty(customerData.get('customer')())) {
          customerData.get('customer').subscribe(function (data) {
            self.isCustomerLoggedIn(true);
            self.showUpgradeLabel(data);
          }, this);
        }
        $('.customer-dashboard-upgrade-options').find('.loader').hide();
      });
    },
    showUpgradeLabel: function (data) {
      $('.category-description h1[data-content-type="heading"]').prepend('<div class="customer-name">' + data.firstname + '</div>');
      if ($('.category-description div[data-content-type="row"] .no-img-description').length > 0 || $('.category-description').find('.pagebuilder-column').length === 1) {
        $('.category-description').addClass('half-width-box');
      }
      this.getMPNOption();
    },
    getMPNOption: function () {
      var _window;
      const self = this;
      const isAlgolia = typeof ((_window = window) === null || _window === void 0 ? void 0 : _window.algolia) !== "undefined";
      if (isAlgolia) {
        window.algolia.earlyUpgrade = {};
      }
      const contractTypes = ['AUS', 'BAU', 'SIMO'];
      self.upgradeOptions().upgrade_options.forEach(item => {
        if (contractTypes.includes(item.type)) {
          self[item.type](priceUtils.formatPrice(item.early_upgrade_fee));
          if (isAlgolia) {
            window.algolia.earlyUpgrade[item.type.toLowerCase()] = $t('Early Upgrade') + ' ' + self[item.type]();
          }
        }
      });
      if (typeof this.contractType === "undefined") {
        return;
      }
      window.earlyUpgrade = {};
      const contractType = this.getTypeByContractType(this.contractType);
      if (contractType === 'PLP') {
        this.updatePlpList();
        if (self.AUS()) {
          if (self.BAU() && self.AUS() !== self.BAU()) {
            self.MPN(`${self.AUS()} or ${self.BAU()}`);
          } else {
            self.MPN(self.AUS());
          }
        }
      } else if (contractType === 'SIMO') {
        this.updateSimoList();
      } else if (contractTypes.includes(contractType) && self[contractType]()) {
        self.MPN(self[contractType]());
        let upgradeButton = $('#upgrade-button .upgrade span');
        let btnText = $t('Upgrade early for') + ' ' + self[contractType]();
        window.earlyUpgrade.btnLabel = btnText;
        setTimeout(function () {
          upgradeButton.text(btnText);
        }, 1000);
      }
      self.visible(true);
    },
    updatePlpList: function () {
      $('.upgrade-options-mpn-block.plp').addClass('loaded');
      let isList = algoliaConfig.isCategoryPage && !!algoliaConfig.category.display_as_list;
      const self = this;
      const algoliaListId = $("#instant-search-results-container .ais-InfiniteHits-list .ais-InfiniteHits-item");
      if (!algoliaListId.length) {
        return;
      }
      algoliaListId.each(function () {
        var _$$children;
        const contractType = (_$$children = $(this).children('.product-item')) === null || _$$children === void 0 ? void 0 : _$$children.data('contract');
        if (!contractType) {
          return;
        }
        let productContractType = self.getTypeByContractType(contractType);
        if (window.algolia.earlyUpgrade[productContractType.toLowerCase()]) {
          $(this).find('.result-promotion-top-line').append('<div class="label early-upgrade"><div class="text">' + window.algolia.earlyUpgrade[productContractType.toLowerCase()] + '</div></div>');
          if (!isList) self.processEqualHeights();
        }
      });
    },
    processEqualHeights: function () {
      if ($('.products.product-items').length) {
        this.equalHeights('.products.product-items', '.product-item-name');
        this.equalHeights('.products.product-items', '.result-lower-content');
        this.equalHeights('.products.product-items', '.result-thumbnail');
      }
      if ($('.ais-Hits-list').length) {
        this.equalHeights('.ais-Hits-list', '.result-pre-content');
        this.equalHeights('.ais-Hits-list', '.ratings');
        this.equalHeights('.ais-Hits-list', '.result-lower-content');
        this.equalHeights('.ais-Hits-list', '.result-thumbnail');
      } else {
        this.equalHeights('.ais-InfiniteHits-list', '.result-pre-content');
        this.equalHeights('.ais-InfiniteHits-list', '.ratings');
        this.equalHeights('.ais-InfiniteHits-list', '.result-lower-content');
        this.equalHeights('.ais-InfiniteHits-list', '.result-thumbnail');
      }
    },
    equalHeights: function (items, item) {
      $(items + ' ' + item).height('unset');
      $(items).each(function () {
        var highestBox = 0;
        $(this).find(item).each(function () {
          if ($(this).height() > highestBox) {
            highestBox = $(this).height();
          }
        });
        $(this).find(item).height(highestBox);
      });
    },
    updateSimoList: function () {
      var _window$algolia$early;
      $('.upgrade-options-mpn-block.plp').addClass('loaded');
      const algoliaListId = $("#instant-search-results-container .ais-InfiniteHits-list .ais-InfiniteHits-item");
      if (!algoliaListId.length || !((_window$algolia$early = window.algolia.earlyUpgrade) !== null && _window$algolia$early !== void 0 && _window$algolia$early.simo)) {
        return;
      }
      algoliaListId.each(function () {
        const contentColumn = $(this).find('.result-content .result-content__column');
        const contentRow = $(this).find('.result-content .result-content__row');
        if (contentColumn.length) {
          contentColumn.append('<div class="label early-upgrade"><div class="text">' + window.algolia.earlyUpgrade.simo + '</div></div>');
          contentRow.append('<div class="label early-upgrade"><div class="text">' + window.algolia.earlyUpgrade.simo + '</div></div>');
        } else {
          $(this).find('.result-content').addClass('has-early-upgrade');
          $(this).find('.result-pre-content').append('<div class="label early-upgrade"><div class="text">' + window.algolia.earlyUpgrade.simo + '</div></div>');
        }
      });
    },
    getTypeByContractType: function (contractTypes) {
      let type = '';
      contractTypes.split(',').forEach(contractType => {
        switch (contractType) {
          case 'AUSTANDARD':
          case 'AUIMMEDIATE':
            type = 'AUS';
            return;
          case 'BAU':
          case 'SIMO':
          case 'PLP':
            type = contractType;
            return;
        }
      });
      return type;
    }
  });
});

